// extracted by mini-css-extract-plugin
module.exports = {"system-component-name":"PartsDiagram_system-component-name__JoaQQ","part-diagram-modal":"PartsDiagram_part-diagram-modal__l33dm"};